import moment from "moment";

export const getDates = (): {
  range: { dateFrom: string; dateTo: string };
  dateFrom: moment.Moment; dateTo: moment.Moment; week: string[]
} => {
  const dayn: number = moment().day();
  const mome1: moment.Moment = moment().subtract(dayn - 1, 'days');
  const mome2: moment.Moment = moment().add(7 - dayn, 'days');
  const newRange = {
    dateFrom: mome1.format("DD MMM YYYY"),
    dateTo: mome2.format("DD MMM YYYY")
  };
  const mo: moment.Moment = moment().subtract(dayn - 1, 'days');
  const array: string[] = getArrayWeek(mo);
  return {
    range: newRange,
    dateFrom: mome1,
    dateTo: mome2,
    week: array
  };
}

export const getTimeFromXDate = (fromDate: string): {
  timeSince: string;
} => {

  const fromMoment: moment.Moment = moment(fromDate);
  const now: moment.Moment = moment();
  const duration = moment.duration(now.diff(fromMoment));
  const days = duration.asDays();

  let timeSince: string;

  if (days >= 1) {
    timeSince = `hace ${Math.floor(days)} días`;
  } else {
    const hours = duration.hours();
    const minutes = duration.minutes();
    if (hours >= 1) {
      timeSince = `hace ${hours} horas ${minutes} minutos`;
    } else {
      timeSince = `hace ${minutes} minutos`;
    }
  }

  return {
    timeSince: timeSince
  };
}

export const getArrayWeek = (data: moment.Moment): string[] => {
  const array: string[] = [];
  for (let i = 0; i < 7; i++) {
    if (i === 0) {
      const m: moment.Moment = data.add(i, 'days');
      array.push(m.format("YYYY-MM-DD"));
    } else {
      const m: moment.Moment = data.add(1, 'days');
      array.push(m.format("YYYY-MM-DD"));
    }
  }
  return array;
}

export const todayDate = (): string => {
  return moment().format("YYYY-MM-DD");
}

export const formatResponse = (response: string) => {
  const formatedResponse = response?.toUpperCase().replace(/ /g, "_")

  return formatedResponse
}

export const calculateTimeRemaining = (exp: number) => {
  const nowInSeconds = Math.floor(Date.now() / 1000);
  const timeRemainingInSeconds = exp - nowInSeconds;

  if (timeRemainingInSeconds <= 0) {
    return {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0,
    };
  }

  const timeRemainingInMinutes = Math.floor(timeRemainingInSeconds / 60);
  const timeRemainingInHours = Math.floor(timeRemainingInMinutes / 60);
  const timeRemainingInDays = Math.floor(timeRemainingInHours / 24);

  console.log(`Tiempo restante: ${timeRemainingInDays} dias, ${timeRemainingInHours % 24} horas, ${timeRemainingInMinutes % 60} minutos y ${timeRemainingInSeconds % 60} segundos`);
};

export const formatDateCreateTask = (date: Date): string => {
  return moment(date).format("YYYY-MM-DD");
};

export const formatCreatedAt = (date: Date): string => {
  return moment(date).format("YYYY-MM-DDTHH:mm:ss");
};
